import React, { useEffect, useState } from "react";
import { Card, Box, Typography, Grid, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import api from "../../utils/api";

const COLOR_MAP = {
  error:   "#dc2626",
  warning: "#b45309",
  info:    "#2f63ad",
};

const NeedsYourAction = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    api.get("/dashboard/needs-action")
      .then((res) => { if (mounted) setData(res.data); })
      .catch(() => { if (mounted) setData(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  if (loading) {
    return (
      <Card sx={{ borderRadius: "18px", p: 3, mb: 3, display: "flex", justifyContent: "center" }}>
        <CircularProgress size={24} />
      </Card>
    );
  }

  if (!data || data.total === 0) return null;

  return (
    <Card
      sx={{
        borderRadius: "18px",
        p: 3,
        mb: 3,
        border: "1px solid rgba(47,99,173,0.08)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
      }}
    >
      <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} md={4}>
          <Typography
            variant="overline"
            sx={{ color: "#6b778c", fontWeight: 700, letterSpacing: 1 }}
          >
            Needs Your Action
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 800, color: "#223142", lineHeight: 1.1, mt: 0.5 }}>
            {data.total}
          </Typography>
          <Typography variant="body2" sx={{ color: "#6b778c", mt: 0.5 }}>
            items waiting on a decision today
          </Typography>

          <Box sx={{ display: "flex", height: 8, borderRadius: "6px", overflow: "hidden", mt: 2, bgcolor: "rgba(0,0,0,0.06)" }}>
            {data.categories.map((c) => (
              c.count > 0 && (
                <Box
                  key={c.key}
                  sx={{
                    width: `${(c.count / data.total) * 100}%`,
                    bgcolor: COLOR_MAP[c.color] || "#6b778c",
                  }}
                />
              )
            ))}
          </Box>
        </Grid>

        <Grid item xs={12} md={8}>
          <Grid container spacing={2}>
            {data.categories.map((c) => (
              <Grid item xs={12} sm={4} key={c.key}>
                <Box
                  component={Link}
                  to={c.link}
                  sx={{
                    display: "block",
                    textDecoration: "none",
                    p: 1.75,
                    borderRadius: "12px",
                    border: "1px solid rgba(47,99,173,0.08)",
                    height: "100%",
                    transition: "background-color 0.15s",
                    "&:hover": { backgroundColor: "rgba(47,99,173,0.04)" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: COLOR_MAP[c.color] || "#6b778c" }} />
                    <Typography variant="body2" sx={{ color: "#6b778c", fontWeight: 600 }}>
                      {c.label}
                    </Typography>
                  </Box>
                  <Typography variant="h5" sx={{ fontWeight: 800, color: "#223142", mt: 0.5 }}>
                    {c.count}
                  </Typography>
                  <Typography variant="caption" sx={{ color: "#9aa5b4" }}>
                    {c.detail}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

export default NeedsYourAction;
